import React from 'react';
import ProductItemView from '../ProductItemView';
import some_features from '../../resource/lis/some_features.svg';


const SomeFeatures = () => {
    return (
        <ProductItemView
            title="Algunas funciones"
            items={["Dashboard customizable por usuario", "Upload de documentos", "Web site mobile friendly para consulta de resultados", "Gestión completa del area de microbiología"]}
            image={some_features} />
    );
};

export default SomeFeatures;